import { useEffect, useRef, useState } from "react";

const Toast = ({ msg, handleShow, bgColor }) => {
	const [visible, setVisible] = useState(true);
	const timerRef = useRef();

	useEffect(() => {
		timerRef.current = setTimeout(() => {
			setVisible(false);
			handleShow && handleShow();
		}, 3000);
		return () => clearTimeout(timerRef.current);
	}, [handleShow]);

	return (
		<div
			className={`toast show position-fixed text-light ${bgColor} ${
				visible ? "toast-slide-in" : "toast-slide-out"
			}`}
			style={{
				top: "5px",
				right: "5px",
				minWidth: "200px",
				zIndex: 5000,
				transition: "transform 0.5s, opacity 0.5s",
				transform: visible ? "translateX(0)" : "translateX(400px)",
				opacity: visible ? 1 : 0,
			}}>
			<div
				className={`toast-header text-light ${bgColor}`}
				style={{ justifyContent: "space-between" }}>
				<strong className="mr-auto text-light">{msg.title}</strong>
				<button
					className="ml-auto mb-1 close text-light"
					data-dismiss="toast"
					style={{
						border: "none",
						background: "none",
						fontSize: "30px",
						right: 0,
					}}
					onClick={() => {
						setVisible(false);
						handleShow && handleShow();
					}}>
					&times;
				</button>
			</div>
			<div className="toast-body">{msg.body}</div>
		</div>
	);
};

export default Toast;
